import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function EmpresasPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Empresas'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'VerEmpresas'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Ver Empresas'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'CadastrarEmpresas'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Cadastrar Empresas'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />
    </>
  )
}
